import { Component, OnInit, OnDestroy, ViewChild, Input, AfterViewInit, forwardRef, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { Logger } from 'src/app/api/helper/app-error-logger';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MyApp } from 'src/app/api/helper/app';
import { IonInput, ModalController } from '@ionic/angular';
import { Utils } from 'src/app/api/helper/utils';
import { InputTextareaPopupPage } from '../input-textarea-popup/input-textarea-popup.page';

const log = new Logger('InputTextarea');

@Component({
    selector: 'app-input-textarea',
    templateUrl: './input-textarea.component.html',
    styleUrls: ['./input-textarea.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputTextarea),
        multi: true
    }],
    standalone: false
})
export class InputTextarea implements ControlValueAccessor, OnInit, OnDestroy, AfterViewInit, OnChanges {
    @ViewChild('input', { read: IonInput, static: true }) input: IonInput;

    @Input() titel: string;
    @Input() lines = 'none';

    @Input() disabled = false;
    @Input() readOnly = false;
    @Input() pattern = '.*';
    @Input() required = false;
    @Input() labelPosition: 'top' | 'left' = 'top';
    @Input() cssClass = '';
    @Input() placeholder = 'Zum Bearbeiten hier tippen';

    @Output() valueChanged = new EventEmitter<any>();
    @Output() lostFocus = new EventEmitter<any>();

    subscriptions: Subscription[] = [];

    isVisible = false;
    isExtraButtonZeile = false;

    autocapitalize: string = null;

    isClearButtonVisible = false;
    isEmptySpaceVisible = false;

    app = MyApp.current;

    private _value: string;

    // Whatever name for this (myValue) you choose here, use it in the .html file.
    public get myValue(): string { return this._value }

    public set myValue(v: string) {
        log?.debug('set myValue: ' + v);

        if (v !== this._value) {
            this._value = v;
            this.onChange(v);
        }
    }

    constructor(
        private modalController: ModalController,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        // log?.debug('changed ' + this.titel, changes);

        this.updateType();
    }

    onChange = (_) => {
        if (this.isVisible) {
            this.validate();
        }
    };

    onTouched = () => { };

    writeValue(value: any): void {
        // log?.debug('writeValue ' + this.titel, value);

        this.myValue = value;

        // setTimeout(() => {
        //     this.validate();
        // });
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
    }

    ngOnInit() {
        // log?.debug('ngOnInit ' + this.titel);

        this.isVisible = true;
        this.updateType();
        this.validate();
    }

    async ngAfterViewInit() {
        // log?.debug('ngAfterViewInit ' + this.titel);

        setTimeout(() => {
            this.validate();
        });
    }

    ngOnDestroy() {
    }

    async ionViewWillEnter() {
    }

    ionViewDidEnter() {
    }

    ionViewWillLeave() {
    }

    onClearValue() {
        this.myValue = null;
        this.valueChanged.next(this._value);

        this.input.setFocus();
    }

    setFocus() {
        try {
            this.input.setFocus();
        } catch (err) {
            log.warn(Utils.getErrorMessage(err), err);
        }
    }

    updateType() {
        this.isClearButtonVisible = false;
        this.isExtraButtonZeile = false;
    }

    onBlur(e: any) {
        // log?.debug('onBlur ' + this.titel);
        this.lostFocus.next(e);
        this.valueChanged.next(this._value);
        this.validate();
    }

    onValueChange(e: any) {
        // log?.debug('onValueChange ' + this.titel);
        this.valueChanged.next(this._value);
        this.validate();
    }

    validate(): boolean {
        // log?.debug('validate ' + this.titel + ': ' + this.pattern + ', value=' + this._value);

        // if (this.pattern && this.pattern != '.*') {
        //     this.isInvalid = false;

        //     try {
        //         const wert = Utils.trimToEmpty(this._value);

        //         if (!wert.match(this.pattern)) {
        //             this.isInvalid = true;
        //         }

        //     } catch (err) {
        //         log.warn('Fehler in Regex ' + this.pattern + ': ' + Utils.getErrorMessage(err));
        //     }
        // }

        return true;
    }

    async onBearbeiten() {
        log?.debug('onBearbeiten: ' + this.titel);

        if (this.readOnly || this.disabled) {
            return;
        }

        const modal = await this.modalController.create({
            component: InputTextareaPopupPage,
            componentProps: {
                'titel': this.titel,
                'text': this.myValue
            }
        });

        await modal.present();

        const modalResult = await modal.onWillDismiss();

        log?.debug('modalResult', modalResult);

        if (modalResult?.data?.dismissed) {
            this.myValue = modalResult.data.text;

            this.valueChanged.next(this._value);
        }


        // if (this.auftrag.Anmerkungen) {
        //     log?.debug('Anmerkungen: ' + this.auftrag.Anmerkungen);

        //     // Anmerkungen wurden eingegeben.
        //     await this.starteAuftragWennErforderlich('Anmerkungen');
        // }

        // this.detectChanges.next('anzeigenAnmerkungen');
    }
}
